// AdminPanelSimple.jsx - Panel de admin simplificado para debugging
import React, { useState } from 'react';
import config from '../config';

const AdminPanelSimple = () => {
  const [isExpanded, setIsExpanded] = useState(false);

  // Capacitor APK sirve desde 'http://localhost' interno → window.location.hostname === 'localhost'.
  // Excluir explícitamente para que el FAB de debug NO aparezca en el APK.
  const isCapacitorAPK = config.isCapacitorNative && config.isCapacitorNative();

  // Detectar si estamos en desarrollo (pero NO en APK)
  const isDev = !isCapacitorAPK && (
    window.location.hostname === 'localhost' ||
    window.location.hostname === '127.0.0.1' ||
    process.env.NODE_ENV === 'development'
  );

  // SIEMPRE mostrar en desarrollo desktop, NUNCA en APK ni producción
  if (!isDev) {
    return null;
  }
  
  return (
    <>
      {/* Botón flotante siempre visible en desarrollo */}
      <div 
        style={{
          position: 'fixed',
          bottom: '20px',
          left: '20px',
          zIndex: 9999
        }}
      >
        <button
          onClick={() => setIsExpanded(!isExpanded)}
          style={{
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            color: 'white',
            padding: '12px',
            borderRadius: '50%',
            border: 'none',
            width: '56px',
            height: '56px',
            cursor: 'pointer',
            boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '24px'
          }}
          title="Panel de Admin"
        >
          🛡️
        </button>
        
        {/* Badge ADMIN */}
        <div 
          style={{
            position: 'absolute',
            top: '-4px',
            right: '-4px',
            background: '#ef4444',
            color: 'white',
            fontSize: '10px',
            padding: '2px 6px',
            borderRadius: '12px',
            fontWeight: 'bold',
            animation: 'pulse 2s infinite'
          }}
        >
          ADMIN
        </div>
      </div>
      
      {/* Panel expandible */}
      {isExpanded && (
        <div 
          style={{
            position: 'fixed',
            bottom: '90px',
            left: '20px',
            zIndex: 9999,
            background: 'white',
            borderRadius: '8px',
            boxShadow: '0 10px 25px rgba(0,0,0,0.2)',
            padding: '16px',
            minWidth: '300px',
            maxWidth: '400px',
            border: '2px solid #8b5cf6'
          }}
        >
          <div style={{ marginBottom: '12px', paddingBottom: '12px', borderBottom: '1px solid #e5e7eb' }}>
            <h3 style={{ margin: 0, color: '#8b5cf6', fontSize: '18px', fontWeight: 'bold' }}>
              👑 Panel de Administrador
            </h3>
            <button
              onClick={() => setIsExpanded(false)}
              style={{
                position: 'absolute',
                top: '12px',
                right: '12px',
                background: 'none',
                border: 'none',
                fontSize: '18px',
                cursor: 'pointer',
                color: '#6b7280'
              }}
            >
              ✕
            </button>
          </div>
          
          <div style={{ fontSize: '14px' }}>
            <div style={{ marginBottom: '8px' }}>
              <strong>Estado:</strong> ✅ Admin Activo
            </div>
            <div style={{ marginBottom: '8px' }}>
              <strong>Entorno:</strong> 🚧 Desarrollo
            </div>
            <div style={{ marginBottom: '8px' }}>
              <strong>Host:</strong> {window.location.hostname}
            </div>
            <div style={{ marginBottom: '8px' }}>
              <strong>NODE_ENV:</strong> {process.env.NODE_ENV || 'No definido'}
            </div>
            
            <div style={{ marginTop: '12px', paddingTop: '12px', borderTop: '1px solid #e5e7eb' }}>
              <p style={{ margin: '0 0 8px 0', fontSize: '12px', color: '#6b7280' }}>
                ✅ Acceso completo a todas las funciones<br/>
                ✅ Sin límites de preguntas<br/>
                ✅ Modo simulacro disponible<br/>
                ✅ Todas las funciones PRO activas
              </p>
            </div>
            
            <div style={{ marginTop: '12px', paddingTop: '12px', borderTop: '1px solid #e5e7eb' }}>
              <button
                onClick={() => {
                  console.log('=== ADMIN DEBUG INFO ===');
                  console.log('Location:', window.location);
                  console.log('ENV:', process.env.NODE_ENV);
                  console.log('LocalStorage:', {...localStorage});
                  alert('Revisa la consola para ver los logs');
                }}
                style={{
                  background: '#3b82f6',
                  color: 'white',
                  padding: '6px 12px',
                  borderRadius: '4px',
                  border: 'none',
                  cursor: 'pointer',
                  fontSize: '12px',
                  marginRight: '8px'
                }}
              >
                🔍 Ver Logs
              </button>
              <button
                onClick={() => {
                  if (window.confirm('¿Limpiar todo el localStorage?')) {
                    localStorage.clear();
                    window.location.reload();
                  }
                }}
                style={{
                  background: '#ef4444',
                  color: 'white',
                  padding: '6px 12px',
                  borderRadius: '4px',
                  border: 'none',
                  cursor: 'pointer',
                  fontSize: '12px'
                }}
              >
                🗑️ Limpiar Cache
              </button>
            </div>
          </div>
        </div>
      )}
      
      <style>{`
        @keyframes pulse {
          0% { transform: scale(1); }
          50% { transform: scale(1.1); }
          100% { transform: scale(1); }
        }
      `}</style>
    </>
  );
};

export default AdminPanelSimple;